/*
 * Матрица уведомлений 4-Б5.
 *
 * ПЕРВЫЙ СТОЛБЕЦ ЗАЛИПАЕТ. Таблица на узкой ширине прокручивается по горизонтали,
 * и без залипания человек видит клетки, не видя, какой они строки, — то есть правит
 * наугад. Событие обязано остаться на экране.
 */
.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-3);
}

.note {
  padding: 10px 14px;
  font-size: var(--font-size-sm);
  line-height: 1.5;
  color: var(--info-fg);
  background: var(--info-bg);
  border-radius: 10px;
}

.warning {
  padding: 10px 14px;
  font-size: var(--font-size-sm);
  line-height: 1.5;
  color: var(--status-pending-fg);
  background: var(--status-pending-bg);
  border-radius: 10px;
}

.error {
  font-size: var(--font-size-sm);
  color: var(--danger);
}

/*
 * Строка, у которой нет источника события: причина написана там же, где у остальных
 * строк подсказка, и тем же размером — это не предупреждение, а объяснение.
 */
.eventPending {
  display: block;
  /* Вровень с названием события, а не с галочкой — как и обычная подсказка ниже. */
  padding-left: 26px;
  font-size: var(--font-size-xs);
  line-height: 1.4;
  color: var(--status-pending-fg);
}

.scroll {
  overflow-x: auto;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-sm);
}

.table th,
.table td {
  padding: 8px 10px;
  border-bottom: 1px solid var(--border);
  text-align: center;
}

/*
 * `.table .eventCell`, а не просто `.eventCell`: правило `.table th` выше по специфичности
 * центрировало ячейку, и подпись под названием события уезжала на середину строки,
 * отрываясь от своего названия.
 */
.table .eventHead,
.table .eventCell {
  position: sticky;
  left: 0;
  z-index: 1;
  min-width: 220px;
  text-align: left;
  background: var(--bg-card);
}

/*
 * ТЕЛЕФОН. Матрица шире экрана по устройству — пять каналов по 64 px, и прокрутка вбок
 * здесь честная. Но столбец событий, который при прокрутке стоит на месте, на телефоне
 * уже: 150 px вместо 220. Иначе рядом с ним помещался ровно один канал, и сравнить
 * «бот или SMS» для одного события было нельзя, не листая туда-обратно.
 */
@media (max-width: 767px) {
  .table .eventHead,
  .table .eventCell {
    min-width: 150px;
  }

  .table th,
  .table td {
    padding: 8px;
  }
}

.kindHead,
.channelHead {
  font-weight: var(--font-weight-semibold);
  white-space: nowrap;
}

.channelSub {
  display: block;
  font-size: var(--font-size-xs-plus);
  font-weight: var(--font-weight-regular);
  color: var(--text-secondary);
}

.eventLabel {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  cursor: pointer;
}

.eventName {
  font-weight: var(--font-weight-semibold);
}

.eventHint {
  display: block;
  padding-left: 26px;
  font-size: var(--font-size-sm);
  font-weight: 400;
  color: var(--text-secondary);
}

.kindCell {
  white-space: nowrap;
}

/* Выключенная строка гаснет целиком: иначе она читается как включённая с пустыми клетками. */
.rowOff .eventName,
.rowOff .kindCell {
  color: var(--text-faint);
}

.cell {
  width: 64px;
}

/*
 * Клетка — КНОПКА, а не галочка: у неё три состояния (включено, выключено, нельзя),
 * и у последнего обязательна подсказка с причиной. Область нажатия 28 px и центр
 * по клетке: на планшете попадают пальцем.
 */
.box {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text-faint);
  cursor: pointer;
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
}

.boxOn {
  color: var(--status-in-progress-fg);
  background: var(--status-in-progress-bg);
  border-color: transparent;
}

/* Неподключённый канал: пунктир, как в макете, — «столбец виден, но не работает». */
.boxOff {
  cursor: not-allowed;
  background: var(--bg-sunken);
  border-style: dashed;
}

.quiet {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: 12px 14px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.quietTitle {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
}

.quietRow {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: flex-end;
}

.quietHint {
  margin: 0;
  font-size: var(--font-size-sm);
  line-height: 1.45;
  color: var(--text-secondary);
}

.saved {
  font-size: var(--font-size-sm);
  color: var(--status-in-progress-fg);
}
